// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__1F1eT","checkmark":"Checkbox_checkmark__WhCPs"};